/**
 * Miele Centre Order System
 * Shared localStorage utility for cart, user, and order history management.
 */
(function () {
  'use strict';

  var CART_KEY = 'mieleCentreCart';
  var USER_KEY = 'mieleCentreUser';
  var HISTORY_KEY = 'mieleCentreOrderHistory';

  function read(key) {
    try {
      var data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      // localStorage full or unavailable
    }
  }

  /* ── Cart ── */

  function getCart() {
    return read(CART_KEY) || [];
  }

  function setCart(items) {
    write(CART_KEY, items);
    document.dispatchEvent(new CustomEvent('miele-cart:updated'));
  }

  function addToCart(item) {
    var cart = getCart();
    item.id = generateId();
    item.dateAdded = new Date().toISOString();
    cart.push(item);
    setCart(cart);
  }

  function getCartCount() {
    return getCart().length;
  }

  /* ── User ── */

  function getUser() {
    return read(USER_KEY);
  }

  function setUser(data) {
    write(USER_KEY, data);
    document.dispatchEvent(new CustomEvent('miele-user:updated'));
  }

  /* ── Order History ── */

  function getOrderHistory() {
    return read(HISTORY_KEY) || [];
  }

  function addToHistory(item) {
    var history = getOrderHistory();
    item.id = item.id || generateId();
    item.dateAdded = item.dateAdded || new Date().toISOString();
    history.push(item);
    write(HISTORY_KEY, history);
  }

  /* ── Auto-clear expired items (2 working days) ── */

  function countWorkingDays(fromDate, toDate) {
    var count = 0;
    var current = new Date(fromDate);
    current.setHours(0, 0, 0, 0);
    var end = new Date(toDate);
    end.setHours(0, 0, 0, 0);

    while (current < end) {
      current.setDate(current.getDate() + 1);
      var day = current.getDay();
      if (day !== 0 && day !== 6) {
        count++;
      }
    }
    return count;
  }

  function cleanExpiredItems() {
    var cart = getCart();
    var now = new Date();
    var filtered = cart.filter(function (item) {
      return countWorkingDays(new Date(item.dateAdded), now) < 2;
    });
    if (filtered.length !== cart.length) {
      setCart(filtered);
    }
  }

  /* ── Header badge ── */

  function updateCartBadge() {
    var count = getCartCount();
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    if (count > 0) {
      icon.classList.add('miele-cart-has-items');
      var bubble = icon.querySelector('.cart-count-bubble');
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        icon.appendChild(bubble);
      }
      bubble.innerHTML =
        '<span aria-hidden="true">' + count + '</span>' +
        '<span class="visually-hidden">' + count + ' solicitudes</span>';
    } else {
      icon.classList.remove('miele-cart-has-items');
      var existingBubble = icon.querySelector('.cart-count-bubble');
      if (existingBubble) existingBubble.remove();
    }
  }

  function updateAccountIcon() {
    var user = getUser();
    var icon = document.getElementById('miele-account-icon');
    if (!icon) return;
    icon.style.display = user ? '' : 'none';
  }

  /* ── Utility ── */

  function generateId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'xxxx-xxxx-xxxx'.replace(/x/g, function () {
      return Math.floor(Math.random() * 16).toString(16);
    });
  }

  /* ── Public API ── */

  window.MieleOrderSystem = {
    getCart: getCart,
    setCart: setCart,
    addToCart: addToCart,
    getCartCount: getCartCount,
    getUser: getUser,
    setUser: setUser,
    getOrderHistory: getOrderHistory,
    addToHistory: addToHistory,
    cleanExpiredItems: cleanExpiredItems,
    updateCartBadge: updateCartBadge,
    updateAccountIcon: updateAccountIcon,
    generateId: generateId
  };

  /* ── Init on DOM ready ── */

  document.addEventListener('DOMContentLoaded', function () {
    cleanExpiredItems();
    updateCartBadge();
    updateAccountIcon();
  });

  document.addEventListener('miele-cart:updated', function () {
    updateCartBadge();
  });

  document.addEventListener('miele-user:updated', function () {
    updateAccountIcon();
  });
})();
